import { Icon, IconProps } from "../Icon";

const List = (props: IconProps) => (
  <Icon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 6H28V8H10V6ZM10 24H28V26H10V24ZM10 15H28V17H10V15ZM4 15H6V17H4V15ZM4 6H6V8H4V6ZM4 24H6V26H4V24Z"
      fill="currentColor"
    />
  </Icon>
);

export default List;
